<template>
  <router-view />
</template>
<script>
import { useConfigStore } from "@/store/configStore";
export default {
  created() {
    const configStore = useConfigStore();
    document.title = configStore.title;
    let userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      sessionStorage.setItem("userInfo", userInfo);
    }
  },
};
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  router-view {
    min-height: 100vh;
  }
}

.el-popper {
  &.is-dark,
  &.is-light {
    max-width: 500px;
    white-space: pre-line;
  }
}
</style>
